export const CompanyName = () => {
    const CompanyName = 'Math Tutor'
    return (

        <span aria-label="" title='Math Tutor'>{CompanyName}</span>

    )
}
export default CompanyName;